/* eslint-disable no-mixed-spaces-and-tabs */
import PropTypes from 'prop-types';

import { testDetailsMap } from '../../constants';

const TestDetails = ({ data, className = '' }) => {
	return (
		<div className={`test-details ${className}`}>
			<table>
				<tbody>
					{data && Object.keys(data).map((detail) => (
						<tr className="test-details__titles-item" key={detail}>
							<td className="test-details__titles-item-title">
								<span className="material-icons">
									{testDetailsMap[detail].icon}
								</span>
								<span className="typography typography--body-small">
									{testDetailsMap[detail].title}
								</span>
							</td>
							<td className="test-details__body-item-body">
								<p className="typography typography--body-small-bold">
									{Array.isArray(data[detail])
										? data[detail].map((a) => a.name).join(', ')
										: data[detail]}
								</p>
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};

TestDetails.propTypes = {
	className: PropTypes.string,
	data: PropTypes.shape({
		cost: PropTypes.any,
		categories: PropTypes.string,
		processingTime: PropTypes.string,
		method: PropTypes.string,
	}),
};

export default TestDetails;
